export default "__VITE_ASSET__eoTnmOD5__";